import {httpUrl} from './httpUrl'

// let baseApi = 'https://upper.damaiiot.com'

let baseUrl = `${httpUrl.host}/gy-apartment`
let baseUrl2 = `${httpUrl.host}/gy-apartment`
let baseUrl85 = `${httpUrl.host}/gy-apartment`

let api = {
  // 登入
  upperLogin: `${baseUrl}/login`,

  // 登出
  upperLogout: `${baseUrl}/logout`,

  // 获取验证码
  upperGetIdentityCode: `${baseUrl}/getIdentityCode`,

  // -------------------------------------   账号  ---------------------------------
  // 账号分页
  getAccountPage: `${baseUrl}/account/getPage`,

  // 添加账号
  addAccount: `${baseUrl}/account/add`,

  // 修改账号
  updateAccount: `${baseUrl}/account/update`,

  // 修改账号密码
  changePassword: `${baseUrl}/account/changePassword`,

  // 删除账号
  deleteAccountByCodes: `${baseUrl}/account/deleteByCodes`,

  // 获取单个账号信息
  getAccountByCode: `${baseUrl}/account/getByCode`,

  // 获取账号列表
  getAccountList: `${baseUrl}/account/getList`,
  // -------------------------------------   账号  ---------------------------------

  // -------------------------------------   角色  ---------------------------------
  // 添加角色
  addRole: `${baseUrl}/role/add`,

  // 修改角色
  updateRole: `${baseUrl}/role/update`,

  // 删除角色
  deleteRoleByCodes: `${baseUrl}/role/deleteByCodes`,

  // 获取单个角色信息
  getRoleByCode: `${baseUrl}/role/getRoleByCode`,

  // ？？？
  getPermissionsByRoleCode: `${baseUrl}/role/getPermissionsByRoleCode`,

  // 获取角色分页
  getRolePage: `${baseUrl}/role/getPage`,

  // 获取角色列表
  getList: `${baseUrl}/role/getList`,
  // -------------------------------------   角色  ---------------------------------

  // -------------------------------------   概览  ---------------------------------
  // 获取园区信息
  getTotalCommunityInfo: `${baseUrl}/overview/getTotalCommunityInfo`,

  // 获取子园区列表
  getCommunityList: `${baseUrl}/overview/getCommunityList`,

  // 获取荣誉列表
  getGroupHonorList: `${baseUrl}/overview/getGroupHonorList`,
  // -------------------------------------   概览  ---------------------------------

  // -------------------------------------   信息发布  ---------------------------------
  // 集团概况
  getGroupInfo: `${baseUrl}/groupInfo/get`,

  // 集团概况
  updateGroupInfo: `${baseUrl}/groupInfo/update`,

  // 荣誉资质分页
  getGroupHonorPage: `${baseUrl}/groupHonor/getPage`,

  // 添加荣誉资质
  addGroupHonor: `${baseUrl}/groupHonor/add`,

  // 修改荣誉资质
  updateGroupHonor: `${baseUrl}/groupHonor/update`,

  // 查询荣誉资质详情
  getGroupHonorByCode: `${baseUrl}/groupHonor/getByCode`,

  // 删除荣誉资质
  deleteGroupHonor: `${baseUrl}/groupHonor/deleteByCodes`,

  // 查询园区公告分页
  getYqNoticePage: `${baseUrl}/groupNews/getPage`,

  // 添加园区公告
  addyqNotice: `${baseUrl}/groupNews/add`,

  // 查询园区公告
  getYqNoticeByCode: `${baseUrl}/groupNews/getByCode`,

  // 修改园区公告
  updateyqNotice: `${baseUrl}/groupNews/update`,

  // 删除园区公告
  deleteyqNoticeByCodes: `${baseUrl}/groupNews/deleteByCodes`,

  // 发布公告
  publishGroupNew: `${baseUrl}/groupNews/publish`,

  // 上传图片
  uploadImg: `${baseUrl}/groupNews/uploadImg`,
  // -------------------------------------   信息发布  ---------------------------------
}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/Summary.js